<template>
  <div class="report-screen">
    <div class="loader" v-show="loader">
      <div class="loader-icon"></div>
    </div>
    <div class="top-panel global-offset">
      <div class="report">
        <div class="arrow"></div>
        <div class="info">
          <p>Reports</p>

          <div class="breadcrumbs-sc">
            <span>Home</span> <i class="glyphicon glyphicon-menu-right"></i>
            Reports
          </div>
        </div>
      </div>
    </div>
    <div class="wrap">
      <div class="r-tree-cont global-offset">
        <div class="r-search">
          Enter your search
        </div>
        <div class="r-tree">
          <div class="r-tree-branch" v-for="(branch, index) in reportsTree" :key="index">
            <div :class="{'r-tree-branch-header': true, 'active': branch.title === 'Predefined' && (currentStep === 1 || currentStep === 2)}">
              <div :class="branch.expanded ? 'r-tree-branch-arrow arrow-open' : 'r-tree-branch-arrow arrow-close'"></div>
              <div class="r-tree-branch-folder"></div>
              <div class="r-tree-branch-title">{{ branch.title }}</div>
            </div>
            <div class="r-tree-branch-content" v-if="branch.expanded">
              <div class="r-tree-branch" v-for="(branch, index) in branch.children" :key="index">
                <div :class="{'r-tree-branch-header': true, 'active': branch.title === 'File Servers' && (currentStep === 3)}"
                     @click="isClickable(branch.step) ? $root.$emit(EVENT_NEXT_STEP) : ''">
                  <div :class="branch.expanded ? 'r-tree-branch-arrow arrow-open' : 'r-tree-branch-arrow arrow-close'"></div>
                  <div class="r-tree-branch-folder"></div>
                  <div class="r-tree-branch-title">{{ branch.title }}</div>
                </div>
                <div class="r-tree-branch-content" v-if="branch.expanded">
                  <div class="r-tree-branch" v-for="(branch, index) in branch.children" :key="index">
                    <div :class="{'r-tree-branch-header': true, 'active': branch.title === 'File Servers — State-in-Time' && (currentStep === 4)}"
                         @click="isClickable(branch.step) ? $root.$emit(EVENT_NEXT_STEP) : ''">
                      <div :class="branch.expanded ? 'r-tree-branch-arrow arrow-open' : 'r-tree-branch-arrow arrow-close'"></div>
                      <div class="r-tree-branch-folder"></div>
                      <div class="r-tree-branch-title">{{ branch.title }}</div>
                    </div>
                    <div class="r-tree-branch-content" v-if="branch.expanded">
                      <div class="r-tree-branch" v-for="(branch, index) in branch.children" :key="index">
                        <div class="r-tree-branch-header" @click="isClickable(branch.step) ? $root.$emit(EVENT_NEXT_STEP) : ''">
                          <div class="r-tree-branch-report"></div>
                          <div class="r-tree-branch-title">{{ branch.title }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="r-content">
        <h4>
          {{ title }}
        </h4>
        <p>
          {{ paragraph }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  import { EVENT_NEXT_STEP } from '@/constants';
  import spacers from '@/mixins/spacers';

  export default {
    name: 'reports-tree-screen-sc4-st-2_4',
    mixins: [spacers],
    data() {
      return {
        currentLeftSpacer: 'spacer-report-list',
        currentRightSpacer: 'spacer-report-list',
        EVENT_NEXT_STEP: EVENT_NEXT_STEP,
        loader: false,
        title: 'Predefined',
        paragraph: 'Ready-to-use reports and dashboards provided by Netwrix.',
        reportsTree: [
          {
            title: 'Predefined',
            expanded: true,
            children: [
              {
                title: 'Organization Level Reports',
                expanded: false,
              },
              {
                title: 'Data Discovery and Classification',
                expanded: false,
              },
              {
                title: 'User Behavior and Blind Spot Analysis',
                expanded: false,
              },
              {
                title: 'Active Directory',
                expanded: false,
              },
              {
                title: 'Azure AD',
                expanded: false,
              },
              {
                title: 'Exchange',
                expanded: false,
              },
              {
                title: 'Echange Online',
                expanded: false,
              },
              {
                title: 'File Servers',
                expanded: false,
                step: 2,
                children: [
                  {
                    title: 'File Servers Activity',
                    expanded: false,
                  },
                  {
                    title: 'File Servers — State-in-Time',
                    expanded: false,
                    step: 3,
                    children: [
                      {
                        title: 'Account Permissions',
                        expanded: false,
                      },
                      {
                        title: 'Duplicate Files',
                        expanded: false,
                      },
                      {
                        title: 'Empty Folders',
                        expanded: false,
                      },
                      {
                        title: 'Execcive Access Permissions',
                        expanded: false,
                      },
                      {
                        title: 'Files and Folder by Owner',
                        expanded: false,
                      },
                      {
                        title: 'Folder and File Permission Details',
                        expanded: false,
                        step: 4,
                      },
                      {
                        title: 'Folder Permissions',
                        expanded: false,
                      },
                      {
                        title: 'Folder Summary Report',
                        expanded: false,
                      },
                      {
                        title: 'Largest Files',
                        expanded: false,
                      },
                      {
                        title: 'Potential Data Owners by Folder',
                        expanded: false,
                      },
                      {
                        title: 'State Data by Folder',
                        expanded: false,
                      },
                      {
                        title: 'Top Owners by Total File Size',
                        expanded: false,
                      },
                    ],
                  },
                ],
              },
              {
                title: 'Network Devices',
                expanded: false,
              },
              {
                title: 'Oracle Database',
                expanded: false,
              },
              {
                title: 'SharePoint',
                expanded: false,
              },
              {
                title: 'SharePoint Online',
                expanded: false,
              },
              {
                title: 'SQL Server',
                expanded: false,
              },
              {
                title: 'VMware',
                expanded: false,
              },
              {
                title: 'Windows Server',
                expanded: false,
              },
            ],
          },
          {
            title: 'Compliance',
            expanded: false,
          },
          {
            title: 'Custom',
            expanded: false,
          },
        ],
      };
    },
    computed: {
      currentStep() {
        return this.$store.state.guide.currentStep;
      },
    },
    watch: {
      currentStep() {
        this.updateTree();
      },
    },
    methods: {
      isClickable(step) {
        return this.currentStep == step;
      },
      updateTree() {
        switch (this.currentStep) {
          case 2:
            this.reportsTree[0].children[7].expanded = false;
            break;
          case 3:
            this.reportsTree[0].children[7].expanded = true;
            this.reportsTree[0].children[7].children[1].expanded = false;
            break;
          case 4:
            this.reportsTree[0].children[7].expanded = true;
            this.reportsTree[0].children[7].children[1].expanded = true;
            break;
        }
      },
    },
    mounted() {
      this.updateTree();
    },
  };
</script>

<style lang="less" scoped>
  @borderLineColor: #d6d7d6;

  .top-panel {
    margin-bottom: 5px;
    text-align: center;
    position: relative;

    .report {
      text-align: left;

      .arrow,
      .info {
        display: inline-block;
        vertical-align: top;
      }

      .arrow {
        width: 26px;
        height: 26px;
        background: url(//img.netwrix.com/elements/onlineDemo/ui_icons/arrow_back_ico.svg) 0 8px no-repeat;
        margin-right: 12px;
      }

      .info {
        p {
          font-size: 22px;
          margin-bottom: 0;
          color: #202020;
        }

        .breadcrumbs-sc {
          color: #58595b;
          font-size: 13px;
          font-weight: 400;
          line-height: 26px;

          .glyphicon {
            font-size: 12px;
          }

          span {
            color: #0d71b9;
          }
        }
      }
    }
  }

  .wrap {
    border-top: 1px solid @borderLineColor;
    border-bottom: 1px solid @borderLineColor;
    white-space: nowrap;
    display: flex;
    align-items: stretch;
  }

  .padding-mixin() {
    padding-top: 10px;
  }

  .r-tree-cont {
    .padding-mixin();
    width: 486px;
    display: inline-block;
    padding-right: 5px;

    .r-search {
      height: 35px;
      border: 1px solid #a6c3d5;
      color: #848284;
      font-size: 13px;
      font-style: italic;
      line-height: 2.4;
      padding-left: 35px;
      margin-bottom: 8px;
      position: relative;

      &:before {
        content: '';
        display: block;
        width: 20px;
        height: 20px;
        background: url('//img.netwrix.com/elements/onlineDemo/ui_icons/search-ico-gray.png') 0 0 no-repeat;
        left: 7px;
        top: 6px;
        position: absolute;
        z-index: 1;
      }
    }

    .r-tree-branch {
      .r-tree-branch-header {
        padding: 6px 0;
        cursor: pointer;

        &.active {
          background: #b6dffe;
        }

        .r-tree-branch-arrow, .r-tree-branch-folder, .r-tree-branch-report, .r-tree-branch-title {
          display: inline-block;
          width: 20px;
          height: 20px;
          vertical-align: top;
        }

        .r-tree-branch-arrow {

          &.arrow-open {
            background: url('//img.netwrix.com/elements/onlineDemo/ui_icons/arrow-opened.png') center no-repeat;
          }

          &.arrow-close {
            background: url('//img.netwrix.com/elements/onlineDemo/ui_icons/arrow-closed.png') center no-repeat;
          }
        }

        .r-tree-branch-folder {
          background: url('//img.netwrix.com/elements/onlineDemo/ui_icons/folder.png') center no-repeat;
        }

        .r-tree-branch-report {
          margin-left: 20px;
          background: url('//img.netwrix.com/elements/onlineDemo/ui_icons/report-ico.png') center no-repeat;
        }

        .r-tree-branch-title {
          width: auto;
          color: #202020;
          font-size: 14px;
          font-weight: 400;
          line-height: 1.6;
        }
      }

      .r-tree-branch-content {
        padding-left: 20px;
      }
    }
  }

  .r-content {
    .padding-mixin();
    display: inline-block;
    vertical-align: top;
    padding-left: 30px;
    white-space: normal;
    width: 960px;

    border-left: 1px solid @borderLineColor;

    h4 {
      color: #202020;
      font-size: 19px;
      font-weight: 400;
      line-height: 31px;
      margin: 0;
    }

    p {
      color: #202020;
      font-size: 13px;
      font-weight: 400;
      line-height: 31px;
    }
  }
</style>